module.exports = __webpack_public_path__ + "img/SCADA CH Line A.b783c2e4.jpg";